import React from 'react';
import { Settings, X } from 'lucide-react';
import ChatUsersList from './ChatUsersList';
import ChatWindow from './ChatWindow';

const ChatPanel = ({ 
  users, 
  selectedUser, 
  onSelectUser, 
  onClose, 
  onSendMessage,
  unreadCounts = {},
  currentUserId,
  onSettingsClick
}) => {
  return (
    <div className="flex flex-col h-full bg-white rounded-lg shadow-xl overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-white">
        <h2 className="text-lg font-semibold text-gray-900">Chat</h2>
        <div className="flex items-center space-x-2">
          <button
            onClick={onSettingsClick}
            className="p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100"
            title="Ustawienia powiadomień"
          >
            <Settings className="h-5 w-5" />
          </button>
          <button
            onClick={onClose}
            className="p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-hidden flex flex-col" style={{ minHeight: 0 }}>
        {selectedUser ? (
          <ChatWindow
            userId={selectedUser.id}
            userName={selectedUser.firstName && selectedUser.lastName 
              ? `${selectedUser.firstName} ${selectedUser.lastName}`
              : selectedUser.email}
            onBack={() => onSelectUser(null)}
            onSendMessage={onSendMessage}
            currentUserId={currentUserId}
          />
        ) : (
          <ChatUsersList
            users={users}
            onSelectUser={onSelectUser}
            unreadCounts={unreadCounts}
          />
        )}
      </div>
    </div>
  );
};

export default ChatPanel;
